import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/**
 * Yozishmalar oynasi — moderator uchun.
 *
 * NEGA ALOHIDA KOMPONENT. Panelda uchta suhbat bor: nizoning ikki
 * tomoni bilan alohida yozishma va uchrashuv chatining o'zi. Ular
 * ilgari uchta joyda uch xil chizilardi — bir xil kulrang qatorlar
 * ro'yxati, kim kimga yozganini faqat ustidagi yozuvdan bilinadigan.
 * Suhbatni o'qiyotgan odam har bir qatorda "bu qaysi tomon edi?"
 * degan savolga qaytardi.
 *
 * Chatning butun ma'nosi TOMONLAR AJRALIB TURISHIDA: chapda bittasi,
 * o'ngda ikkinchisi. Shakl ma'lumotni yozuvsiz uzatadi.
 */
export function ChatWindow({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        // Ichkaridan aylantiriladi: uzun suhbat sahifani cho'zib
        // yuborsa, qaror paneli ekrandan chiqib ketardi.
        "bg-muted/30 max-h-[28rem] min-h-40 space-y-3 overflow-y-auto rounded-xl p-3",
        className,
      )}
    >
      {children}
    </div>
  );
}

/**
 * Bitta xabar.
 *
 * `side` — kim yozgani: `right` har doim "biz tomon" (moderator yoki
 * shikoyatchi), `left` — ikkinchi tomon. Rang ham shu bilan
 * bog'langan: o'ng tomondagi xabar brend rangida, chapdagi neytral.
 */
export function ChatBubble({
  side,
  author,
  time,
  note,
  children,
}: {
  side: "left" | "right";
  author: string;
  time: string;
  /** Qo'shimcha belgi: manba (Telegram), o'qilgani va shunga o'xshash. */
  note?: string;
  children: ReactNode;
}) {
  const right = side === "right";

  return (
    <div className={cn("flex", right ? "justify-end" : "justify-start")}>
      <div className={cn("flex max-w-[85%] flex-col gap-1", right ? "items-end" : "items-start")}>
        <span className="text-muted-foreground px-1 text-[11px]">
          {author}
          {note && ` · ${note}`}
        </span>

        {/* Bir burchak o'tkir: qabariq qaysi tomondan "o'sib
            chiqqanini" ko'rsatadi — Telegram va iMessage'dagi bilan
            bir xil ishora, va u rangdan ko'ra ishonchliroq (rang
            ko'rmaydigan odam ham ajratadi). */}
        <div
          className={cn(
            "rounded-2xl px-3 py-2 text-sm leading-relaxed break-words whitespace-pre-line",
            right
              ? "bg-primary text-primary-foreground rounded-br-sm"
              : "bg-background rounded-bl-sm border",
          )}
        >
          {children}
        </div>

        <span className="text-muted-foreground px-1 text-[10px] tabular-nums">{time}</span>
      </div>
    </div>
  );
}
